import { IonSpinner } from "@ionic/react";
import React, { useState } from "react";
import { GoogleIcon, FacebookIcon, AppleIcon } from "../../assets/icons";

type SocialProvider = "google" | "facebook" | "apple";

interface SocialButtonsProps {
  handleSocialRegister: (provider: SocialProvider) => void;
}

const SocialButtons: React.FC<SocialButtonsProps> = ({ handleSocialRegister }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const enabledProviders: SocialProvider[] = ["google", "facebook", "apple"];

  const handleClick = (provider: SocialProvider) => {
    if (loading) return;

    setLoading(true);
    setLoadingMessage(provider);

    handleSocialRegister(provider);

    // optional timeout to reset spinner (simulate async)
    setTimeout(() => {
      setLoading(false);
      setLoadingMessage("");
    }, 2000);
  };

  const renderButton = (
    provider: SocialProvider, 
    IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>
  ) => (
    <div
      key={provider}
      className={`social-button ${provider}-button ${loading ? "disabled" : ""}`}
      onClick={() => handleClick(provider)}
    >
      {loading && loadingMessage === provider ? (
        <IonSpinner name="dots" />
      ) : (
        <IconComponent className="social-icon" aria-label={provider} />
      )}
    </div>
  );

  return (
    <div className="social-buttons-container">
      {enabledProviders.includes("google") && renderButton("google", GoogleIcon)}
      {enabledProviders.includes("facebook") && renderButton("facebook", FacebookIcon)}
      {enabledProviders.includes("apple") && renderButton("apple", AppleIcon)}
    </div>
  );
};

export default SocialButtons;